module.exports = "main {\n  margin-left: 2em;\n  margin-right: 2em; }\n\nh4 {\n  font-weight: bold;\n  margin-top: 15px; }\n\n.btn-floating {\n  padding: 5px 10px;\n  background: #fff;\n  margin: 10px 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/darkadia.component.scss
// module id = ./src/app/darkadia.component.scss
// module chunks = main